import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import imageDesktopWebp from './images/north-building-desktop.webp';
import imageMobileWebp from './images/north-building-mobile.webp';

export default () => (
  <InformationalModule
    // configs
    sectionId='sustainability-impact-environment-new-north'
    themeType='lightTheme'
    backgroundVariant='lightA'
    moduleName='financial-planning-module'
    moduleVariation='A'
    reverseContent={false}
    // content
    subHeadingText={<>Modernizing our North <WidowBlock>Office Building</WidowBlock></>}
    // column content
    columnContentA={(
      <Typography disableBottomPadding>
        In 2023, we launched a &#36;500 million investment in our North Office Building at our downtown Milwaukee campus. Extensive renovations to the 1990 building will mirror the award&#45;winning Tower and Commons and emphasize sustainability&#8212;featuring advanced energy measurement, creative reuse of materials, lower&#45;impact materials, and employee&#45;focused spaces. Whole building life cycle assessments help us understand the environmental benefits from these changes.
      </Typography>
    )}
    // image props
    imageAltText='Construction work taking place on the New North building'
    imageSrcDefault={imageDesktopWebp}
    imageSrcMobile={imageMobileWebp}
  />
);
